import z from "zod";

import { sizeAttributeSchema } from "@frontend/bridge/sizeSchema";
import { SIZES } from "@frontend/styles/constants";

export const knobDataSchema = z.object({
  label: z.string().optional(),
  value: z.coerce.number().optional(),
  min: z.coerce.number().optional(),
  max: z.coerce.number().optional(),
  step: z.coerce.number().optional(),
  size: sizeAttributeSchema(SIZES).optional(),
  disabled: z
    .string()
    .optional()
    .transform((value) => value !== undefined && value !== "false"),
});

export type KnobDataProps = z.infer<typeof knobDataSchema>;
